import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ContentComponent } from './content/content.component';

import { TrainingComponent } from './training/training.component';
import { ModuleComponent } from './module/module.component';
import { LectureComponent } from './module/lecture/lecture.component';

const routes: Routes = [
  {
    path: '',
    component: ContentComponent,
  },
  {
    path: 'tests/:id',
    component: TrainingComponent
  },
  {
    path: 'modules/:id',
    component: ModuleComponent,
    children: [
      {
        path: '',
        redirectTo: 'lectures/1',
        pathMatch: 'full'
      },
      {
        path: 'lectures/:position',
        component: LectureComponent,
        data: { title: 'Lecture page' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/app-routing.module.ts